import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  isIframe = false;
  switchLang(lang: string) {
    this.translate.use(lang);
  }
  constructor(public translate: TranslateService){
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    this.switchLang("en");
  }
}
